/* eslint-disable */
import qs from 'qs';
import { axios, path, formAxios } from './config';
import { prune } from '../helpers';
import { pageNum, productTypes, APP_NAME } from 'appConstants';
import config from 'config';
import { getAPIDateTimeFormat, formattedHeaders } from './helpers';

const { ONE, TEN, HUNDRED } = pageNum;

export function statistics(userId) {
  return axios.get(path.STATISTICS, { params: { userId } });
}

export function finalize({ fullName, password, companyName, phone, contactMe }) {
  return axios.get(path.FINALIZE, {
    params: {
      full_name: fullName,
      password,
      name: companyName,
      phone,
      contact_me: contactMe,
    },
  });
}

export function signup({
  firstName,
  lastName,
  companyName,
  email,
  password1,
  password2,
  areaCode,
  companySize,
  jobTitle,
  phone,
  method,
}) {
  const params = prune({
    new_username: email,
    first_name: firstName,
    last_name: lastName,
    name: companyName,
    phone,
    new_password_1: password1,
    new_password_2: password2,
    areacode: areaCode,
    company_size: companySize,
    job_title: jobTitle,
    method,
  });

  return axios.get(path.NEW_ACCOUNT, { params });
}

export function payInvoice({ invoiceId, token }) {
  const params = {
    id: invoiceId,
    card_token: token,
  };
  return axios.get(path.CUSTOMER_INVOICE_PAY, { params });
}

export function getInvoice(invoiceId) {
  return axios.get(path.CUSTOMER_INVOICE, {
    params: {
      id: invoiceId,
    },
  });
}

export function customer() {
  return axios.get(path.CUSTOMER);
}

export function customerBasic({ accountId }) {
  const body = {
    account_id: accountId,
    customer_id: accountId,
  };
  return axios.post(path.GET_BASIC_CUSTOMER_INFO, body, {
    forceUpdate: true,
  });
}

export function customerStats() {
  return axios.get(path.CUSTOMER_STATS);
}

export function saveSendTimeRestrictions({
  enabled = false,
  startHourLocal,
  endHourLocal,
  localTimezone,
}) {
  const params = {
    enabled,
  };
  if (enabled) {
    params.start_hour = startHourLocal;
    params.end_hour = endHourLocal;
    params.timezone = localTimezone;
  }
  return axios.post(path.CUSTOMER_SEND_TIME_RESTRICTION_UPDATE + qs.stringify({ ...params }));
}

export function updateMessageOptions({
  templateStrictMode,
  disableFreetext,
  customizedOptOutMessageText,
  initialOptoutEnabled,
  userCanManageOptOut,
}) {
  const params = {
    strict_mode: templateStrictMode,
    disable_freetext: disableFreetext,
    initial_opt_out_msg: customizedOptOutMessageText,
    initial_opt_out_enabled: initialOptoutEnabled,
    user_can_manage_opt_out: userCanManageOptOut,
  };

  return axios.post(path.CUSTOMER_MESSAGE_OPTIONS_UPDATE + qs.stringify({ ...params }));
}

export function setCreditCard(cardToken) {
  const params = {
    card_token: cardToken,
  };

  return axios.get(path.CUSTOMER_BILLING_CARD_SET, { params });
}

export function subscribe({ planId, seats }) {
  const params = {
    plan: planId,
    seats,
  };

  return axios.get(path.CUSTOMER_BILLING_SUBSCRIBE, { params });
}

export function cancel() {
  return axios.get(path.CUSTOMER_BILLING_CANCEL);
}

export function billingDetails() {
  return axios.get(path.CUSTOMER_BILLING_DETAILS);
}

export function convertSort(filters) {
  let direction = '+';
  if (filters.reverse) {
    direction = '-';
  }

  direction += filters.order;
  return direction;
}

export function integrationEvents({ filter, itemsPerPage, sort, code, pageNumber }) {
  const params = {
    filter: JSON.stringify(filter),
    items_per_page: itemsPerPage || TEN,
    page: pageNumber,
    sort: sort,
    code,
  };
  return axios.get(path.CUSTOMER_INT_EVENTS, { params });
}

export function saveIntegrationFieldsApi({ fields, customerId }) {
  const params = {
    account_id: customerId,
    fields: JSON.stringify(fields),
  };
  formAxios.post(`${path.CUSTOMER_INT_SAVE_FIELDS}${qs.stringify(params)}`);
}

export function saveIntegrationMessageTemplate({ code, name, text, templateId, share }) {
  const params = {
    code,
    name,
    text,
    share,
  };
  if (templateId !== null) {
    params.message_template_id = templateId;
  }

  return axios.post(path.CUSTOMER_INT_ADD_UPDATE_TEMPLATE, { params });
}

export function getCustomerTemplates({
  pageNumber = ONE,
  itemsPerPage = TEN,
  sort,
  code,
  shareFilter = 'SHAREONLY',
  type,
}) {
  return axios.get(path.MESSAGE_TEMPLATES, {
    params: {
      items_per_page: itemsPerPage,
      page: pageNumber,
      code,
      share_filter: shareFilter,
      sort,
      type,
    },
    forceUpdate: true,
  });
}

export function uploadAriResponses({ selectedFile, uid }) {
  const params = {
    uid,
  };

  const uploadData = new FormData();
  uploadData.append('file', selectedFile);
  return axios.post(`${path.CANDIDATE_FILE_UPLOAD}${qs.stringify(params)}`, uploadData);
}

export function importAriResponses({ uploadHeaders, customerId, uid, selectedAriSequence, ari }) {
  const params = {
    account_id: customerId,
    uid,
  };

  const data = {
    uid,
    account_id: customerId,
    fields: JSON.stringify(formattedHeaders(uploadHeaders)),
    client_ver: config.clientVersion,
    app_name: APP_NAME,
    product: productTypes.TEXT_RECRUIT,
    ari: ari,
    sequenceId: selectedAriSequence.id,
  };

  return formAxios.post(
    `${path.ARI_RESPONSES_IMPORT_FILE}${qs.stringify(params)}`,
    qs.stringify(data),
  );
}

export function sequences({ filter, hasConfigurableAri, hasRecruitingAri }) {
  const params = {
    items_per_page: HUNDRED,
  };
  const queryFilter = [];
  if (filter) {
    if (filter.showAnalytics) {
      queryFilter.push({
        fieldName: 'showAnalytics',
        type: 'Equals',
        value: true,
      });
    }
    if (filter.facebook) {
      queryFilter.push({ fieldName: 'facebook', type: 'Equals', value: true });
    }

    if (filter.ariType) {
      params.ari_type = filter.ariType;
    }

    if (hasConfigurableAri) {
      params.has_configurable_ari = hasConfigurableAri;
    }

    if (hasRecruitingAri) {
      params.has_recruiting_ari = hasRecruitingAri;
    }
  }

  params.filter = JSON.stringify(queryFilter);

  return axios.get(path.SEQUENCES, { params });
}

export function getScheduledMessage({ id }) {
  const params = {
    id,
  };

  return axios.get(path.GET_SCHEDULED_MESSAGE, {
    params,
  });
}

export function scheduleMessage({ sendTo, dripMessages, sendAs, id }) {
  dripMessages.forEach((msg) => {
    msg.sendDate = getAPIDateTimeFormat(msg.sendDate) + '+0000';
  });

  const params = {
    send_to: JSON.stringify(sendTo),
    send_as: sendAs,
    drip_messages: JSON.stringify(dripMessages),
  };

  if (id) {
    params.id = id;
  }

  return axios.post(path.SCHEDULED_MESSAGE + qs.stringify({ ...params }));
}

export function fetchAriIntents({
  sequenceId,
  page = ONE,
  itemsPerPage = TEN,
  sort,
  language,
  ariIntentsSearchKey,
  ariType,
}) {
  const params = {
    sequence_id: sequenceId,
    items_per_page: itemsPerPage,
    page: page,
    sort,
    language,
    ari_type: ariType,
    intent_search: ariIntentsSearchKey,
  };

  return axios.get(path.FETCH_ARI_INTENTS, {
    params,
  });
}

export function fetchVectorSearchResults({ searchAriQuery, sequenceId }) {
  const params = {
    query: searchAriQuery,
  };

  if (sequenceId) {
    params.sequence_id = sequenceId;
  }

  return axios.post(path.FETCH_VECTOR_SEARCH_RESULTS + qs.stringify({ ...params }));
}

export function fetchAriIntentData({ sequenceId, accountId, ariCategory, ari }) {
  const params = {
    sequence_id: sequenceId,
    account_id: accountId,
    intent_name: ariCategory,
    ari_type: ari,
  };

  return axios.get(path.ARI_EDIT_RESPONSES, {
    params,
  });
}

export function fetchCandidatesInSequence({ sendTo }) {
  const params = {
    send_to: JSON.stringify(sendTo),
  };

  return axios.get(path.CANDIDATES_IN_SEQUENCE, {
    params,
  });
}

export function addAriIntentData({ addIntent, escalate, name, sequenceId, ari }) {
  const params = {
    sequence_id: sequenceId,
    ari: ari,
    name: name,
    escalate: escalate,
    add_intents: JSON.stringify(addIntent),
  };

  return formAxios.post(path.ADD_ARI_EDIT_RESPONSES + qs.stringify({ ...params }));
}

// TODO: account id mandatory for all apis. need a separate ticket to handle this.
export const downloadAriResponsesApi = async ({ sequenceId, isLegacyAri }) => {
  const sequenceIdParam = isLegacyAri ? '' : `&sequence_id=${sequenceId}`;

  return axios.get(
    `${path.ARI_INTENTS_EXPORT}filter=[{"fieldName":"ariName","type":"Equals","value":"RecruitingAri"}]${sequenceIdParam}`,

    { responseType: 'stream', ContentType: 'multipart/form-data' },
  );
};

export function getTermsOfService({ termsOfServiceRecordId }) {
  const params = {
    tos_id: termsOfServiceRecordId,
  };

  return axios.get(path.GET_TOS, {
    params,
  });
}

export function agreeTermsOfService({ termsOfServiceRecord }) {
  return axios.post(
    `${path.CONFIRM_TOS}?tos_id=${termsOfServiceRecord.id}&customer_wide=${termsOfServiceRecord.customerWide}`,
  );
}

export const getCorpusData = ({ ariType, sequenceId }) => {
  const params = {
    type: ariType,
  };

  if (sequenceId) {
    params.sequence_id = sequenceId;
  }

  return axios.get(path.GET_CORPUS_DATA, { params });
};

export const removeCorpusData = ({ ariType, fileName, sequenceId }) => {
  const params = {
    type: ariType,
    file_name: fileName,
  };

  if (sequenceId) {
    params.sequence_id = sequenceId;
  }

  return axios.delete(path.DELETE_CORPUS_DATA, { params });
};

export const upgradeSequenceToUseKnowledgeBaseApi = ({ sequenceId }) => {
  if (!sequenceId) {
    return axios.post(path.UPGRADE_SEQUENCE_TO_USE_KNOWLEDGE_BASE);
  }

  return axios.post(`${path.UPGRADE_SEQUENCE_TO_USE_KNOWLEDGE_BASE}?sequence_id=${sequenceId}`);
};

export const uploadCorpusData = ({ ariType, files, sequenceId, replaceFileName }) => {
  const uploadData = new FormData();
  const params = {
    type: ariType,
  };

  if (sequenceId) {
    params.sequence_ids = `[${sequenceId}]`;
  }

  if (replaceFileName) {
    uploadData.append('replaceFileName', replaceFileName);
  }

  files.forEach((file) => {
    uploadData.append('files', file);
  });

  return axios.post(`${path.UPLOAD_CORPUS_DATA}`, uploadData, { params });
};

export const importStructuredResponses = ({ sequenceId }) => {
  const params = {};
  if (sequenceId) {
    params.sequence_ids = `[${sequenceId}]`;
  }

  return axios.post(path.IMPORT_STRUCTURED_RESPONSE, null, { params });
};

export function getOrCreateDemoJobchatSequence({ sequenceDefinitionId }) {
  if (!sequenceDefinitionId) {
    return axios.post(path.GET_OR_CREATE_DEMO_SEQUENCE);
  }

  return axios.post(`${path.GET_OR_CREATE_DEMO_SEQUENCE}?sequence_id=${sequenceDefinitionId}`);
}

export function downloadCorpusData({ fileKey }) {
  return axios.get(`${path.DOWNLOAD_CORPUS_DATA}?key=${fileKey}`);
}

export const updateSequenceDefinition = ({
  sequenceId,
  useDefaultGreeting,
  useDefaultAffirmativeResponse,
  digitalAssistantGreeting,
  greetingAffirmativeResponse,
}) => {
  const params = {
    sequence_id: sequenceId,
    use_default_affirmative_response: useDefaultAffirmativeResponse,
    use_default_greeting: useDefaultGreeting,
  };

  // Handle digitalAssistantGreeting with language-coded greeting structure
  if (digitalAssistantGreeting) {
    const greetingData = {
      ...digitalAssistantGreeting,
    };

    // The greeting object already has language codes as keys (e.g., { en: "greeting text", de: "german greeting" })
    // So we can pass it directly
    params.digital_assistant_greeting = JSON.stringify(greetingData);
  }

  // Handle greetingAffirmativeResponse with language-coded negativeResponse structure
  if (greetingAffirmativeResponse) {
    const affirmativeData = {
      requiresAffirmativeResponse: greetingAffirmativeResponse.requiresAffirmativeResponse,
      negativeResponse: greetingAffirmativeResponse.negativeResponse, // This already has language codes as keys
    };

    params.greeting_affirmative_response = JSON.stringify(affirmativeData);
  }

  return axios.put(path.UPDATE_SEQUENCE + qs.stringify({ ...params }));
};
